import React from 'react';

export const BCFormInput = ({
  onChange,
  name,
  value,
  label,
  disabled = false,
  error,
}) => (
  <div className="BCFormInput__container">
    <div className="BCFormInput__labelerror">
      <label className="BCFormInput__label">{label}</label>
      {error && <p className="BCFormInput__error">*{error}</p>}
    </div>

    <input
      className="BCFormInput__input"
      name={name}
      placeholder={label}
      onChange={onChange}
      value={value ?? ''}
      disabled={disabled}
    ></input>
  </div>
);
